import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Loader2, ShieldCheck } from "lucide-react";
import { useAdminAuth } from "@/admin/AdminAuth";
import { apiError } from "@/admin/api";

export default function AdminLogin() {
  const { login } = useAdminAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back");
      nav("/admin");
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[hsl(160_38%_10%)] px-4">
      <form onSubmit={submit} data-testid="admin-login-form"
            className="w-full max-w-sm bg-white rounded-2xl p-8 shadow-2xl">
        <div className="flex items-center gap-2 mb-1 text-[hsl(160_38%_16%)]">
          <ShieldCheck size={22} />
          <span className="font-serif text-2xl">Findivine Admin</span>
        </div>
        <p className="text-sm text-gray-500 mb-6">Sign in to manage donations & content.</p>
        <label className="text-xs font-semibold uppercase tracking-wider text-gray-500">Email</label>
        <input data-testid="login-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)}
               className="mt-1 mb-4 w-full rounded-lg border border-gray-300 px-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-[hsl(13_65%_54%)]" />
        <label className="text-xs font-semibold uppercase tracking-wider text-gray-500">Password</label>
        <input data-testid="login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)}
               className="mt-1 mb-6 w-full rounded-lg border border-gray-300 px-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-[hsl(13_65%_54%)]" />
        <button data-testid="login-submit" disabled={loading}
                className="w-full rounded-lg bg-[hsl(13_65%_54%)] text-white py-2.5 text-sm font-semibold inline-flex items-center justify-center gap-2 disabled:opacity-60">
          {loading && <Loader2 size={16} className="animate-spin" />} Sign In
        </button>
      </form>
    </div>
  );
}
